const indexItems = [
  { title: '娱乐圈黑料合集', desc: '明星八卦、合约纠纷、私生活风波', icon: 'ri-star-line', color: 'primary' },
  { title: '网红圈塌房实录', desc: '网红博主翻车事件全记录', icon: 'ri-user-smile-line', color: 'accent' },
  { title: '社会热点深扒', desc: '社会事件内幕与真相追踪报道', icon: 'ri-global-line', color: 'secondary' },
  { title: '科技圈爆料台', desc: '科技公司内幕、产品造假揭露', icon: 'ri-cpu-line', color: 'primary' },
  { title: '体育圈黑幕', desc: '赛事黑哨、选手丑闻深度调查', icon: 'ri-trophy-line', color: 'accent' },
  { title: '直播圈内幕', desc: '主播纠纷、平台潜规则大起底', icon: 'ri-live-line', color: 'secondary' },
  { title: '金融圈风暴', desc: '金融诈骗、资本运作内幕曝光', icon: 'ri-funds-line', color: 'primary' },
  { title: '食品安全曝光', desc: '餐饮后厨、食品造假实地调查', icon: 'ri-restaurant-line', color: 'accent' },
  { title: '影视圈潜规则', desc: '剧组内幕、选角黑箱全揭秘', icon: 'ri-film-line', color: 'secondary' },
];

const colorMap: Record<string, { bg: string; text: string; icon: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-600', icon: 'text-primary-500' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-600', icon: 'text-accent-500' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-600', icon: 'text-secondary-500' },
};

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900 mb-3">专题索引</h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">按不同领域分类浏览精彩黑料内容，快速找到您感兴趣的话题</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-4xl mx-auto">
          {indexItems.map((item, i) => {
            const c = colorMap[item.color];
            return (
              <a
                key={i}
                href="#topics"
                className="flex items-start gap-4 p-4 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200/60 transition-all duration-200 cursor-pointer no-underline group"
              >
                <div className={`w-10 h-10 rounded-xl ${c.bg} flex items-center justify-center flex-shrink-0`}>
                  <i className={`${item.icon} text-lg ${c.icon}`} />
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-bold text-foreground-800 group-hover:text-primary-500 transition-colors mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}